module.exports = __webpack_public_path__ + "static/media/etude-quantitative-sur-securite-des-packaging-des-piles-boutons-mini.9646a75e.jpg";